import type * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex field-sizing-content min-h-16 w-full rounded-xl border bg-background px-4 py-3 text-md shadow-xs transition-all duration-200 outline-none hover:border-foreground/40 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-base",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
